import styled from '@emotion/styled';
import { IconCheckbox } from '@shared/ui/inputs/iconCheckbox/index';

export const SIconCheckbox = styled(IconCheckbox)`
  padding: 7px 10px;
  align-items: unset;
  width: 100%;
`;

export const SCheckboxes = styled.div`
  margin: 0 10px;
`;
